angular.module('project')
    .controller('ProjectShowController', function ($scope, $http, $httpParamSerializer, Principal, toastr, data, $uibModalInstance, $rootScope, Project, Property, PropertyService, ProjectService, ProjectConst, modals) {
        this.item = data;
        this.PropertyService = PropertyService;
        this.ProjectService = ProjectService;

        this.$onInit = () => {
            this.canReadWorkflow = Principal.hasAnyAuthority(["ROLE_WORKFLOW_MODULE"]);
            this.canReadPowerOfAttorney = Principal.hasAnyAuthority(["ROLE_POWER_OF_ATTORNEY_MODULE"]);
            this.canReadServiceRequests = Principal.hasAnyAuthority(["ROLE_SERVICE_REQUEST"]);
            this.canReadInvoice = Principal.hasAnyAuthority(["ROLE_INVOICE_DOCUMENTS_MODULE"]);
            this.canReadAgreements = Principal.hasAnyAuthority(["ROLE_CONTRACT_MODULE"]);
            this.canReadOrders = Principal.hasAnyAuthority(["ROLE_CONTRACT_MODULE"]);
            this.canReadOffers = Principal.hasAnyAuthority(["ROLE_ADMIN"]);
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
            this.canReadPropertyPriceTransparency = Principal.hasAnyAuthority(['ROLE_PROPERTY_PRICE_TRANSPARENCY']);
        }

        this.searchDocs = () => {
            this.query = this.searchQuery
        }
        this.resetSearch = () => {
            this.searchQuery = null;
            this.searchDocs()
        }

        this.onWorkflowLoaded = page => this.workflowCount = page.fullListSize || 0
        this.onPowerOfAttorneyLoaded = page => this.powerOfAttorneyCount = page.fullListSize || 0
        this.onServiceRequestLoaded = page => this.serviceRequestCount = page.fullListSize || 0
        this.onInvoiceLoaded = page => this.invoiceCount = page.fullListSize || 0
        this.onAgreementLoaded = page => this.agreementCount = page.fullListSize || 0
        this.onOrderLoaded = page => this.orderCount = page.fullListSize || 0
        this.onOfferLoaded = page => this.offerCount = page.fullListSize || 0

        this.sendTransparency = () => {
            return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/send")
                .then(() => {
                    toastr.success("Aktualny plik CSV projektu " + this.item.name + " wysłano na FTP");
                }).catch(() => {
                    toastr.error("Nie udało się wysłać pliku CSV na FTP");
                });
        }

        this.sendGovFtp = (params) => {
            return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/gov?" + $httpParamSerializer(params))
                .then(() => {
                    toastr.success(params && params.forceAgain ? "Ponowiono dzisiejszą publikację dla dane.gov.pl" : "Opublikowano dzisiejsze dane dla dane.gov.pl");
                }).catch(() => {
                    toastr.error(params && params.forceAgain ? "Nie udało się ponowić dzisiejszej publikacji" : "Nie udało się opublikować dzisiejszych danych");
                });
        }

        this.openGovPublicationModal = () => modals.open('app/project/transparency-publication-modal.html', 'ProjectTransparencyPublicationController', {id: this.item.id, name: this.item.name}, {size: 'sm'}, '$ctrl')

        this.generateMd5Ftp = (params) => {
            return $http.post("/crm/api/property-price-transparency/" + this.item.id + "/generate-md5?" + $httpParamSerializer(params))
                .then(() => {
                    toastr.success("Przeliczono, wysłano i zweryfikowano plik MD5");
                }).catch(() => {
                    toastr.error("Nie udało się przeliczyć i wysłać pliku MD5");
                });
        }

        this.getExportUrlForProjectPriceTransparency = (params) => {
            return "/crm/api/property-price-transparency/" + this.item.id + "/export?" + $httpParamSerializer(params)
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        $scope.$on(ProjectConst.eventUpdate, () => Project.get({id: this.item.id}, entity => this.item = entity))
    })
    .controller('ProjectTransparencyPublicationController', function ($http, $httpParamSerializer, $q, $uibModalInstance, toastr, data) {
        const toLocalDate = value => {
            if (!value || typeof value === 'string')
                return value;
            const pad = number => number.toString().padStart(2, '0');
            return [value.getFullYear(), pad(value.getMonth() + 1), pad(value.getDate())].join('-');
        }

        this.project = data;
        this.mode = 'TODAY';
        this.today = toLocalDate(new Date());

        this.publish = () => {
            const publicationDate = this.mode === 'SELECTED_DATE' ? toLocalDate(this.publicationDate) : null;
            const params = publicationDate ? {publicationDate} : {};
            return $http.post('/crm/api/property-price-transparency/' + this.project.id + '/gov?' + $httpParamSerializer(params))
                .then(() => {
                    toastr.success(publicationDate ? 'Opublikowano dane z datą ' + publicationDate + ' dla dane.gov.pl' : 'Opublikowano dzisiejsze dane dla dane.gov.pl');
                    $uibModalInstance.close();
                })
                .catch(rejection => {
                    if (!rejection.data || !angular.isArray(rejection.data.messages))
                        toastr.error('Nie udało się opublikować danych');
                    return $q.reject(rejection);
                });
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
